var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProductFinder',{attrs:{"forceLoading":_vm.productId && !_vm.loaded,"remove-price":true},model:{value:(_vm.products),callback:function ($$v) {_vm.products=$$v},expression:"products"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }